import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/flag/icon-flag-en.svg")